import axios from "axios";
import TokenService from "./Token.service";
import { showToastMessage } from '../Utils/ToastUtils';


const dirPath = process.env.REACT_APP_SUB_DIR;
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

let isRefreshing = false; // Tracks if the token refresh is in progress
let failedQueue = []; // Holds requests waiting for the refr

const processQueue = (error, token = null) => {
    failedQueue.forEach(promise => {
        if (token) {
            promise.resolve(token); // Retry with the new token
        } else {
            promise.reject(error); // Reject all if refresh failed
        }
    });
    failedQueue = [];
};

const retryFailedRequest = (originalConfig) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            instance(originalConfig)
                .then(resolve)
                .catch(reject);
        }, 1000);
    });
};

instance.interceptors.request.use(
    (config) => {
        const token = TokenService.getAccessToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
instance.interceptors.response.use(
    res => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (err.response) {

            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                // Wait if refresh is already in progress
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                        .then((token) => {
                            originalConfig.headers["Authorization"] = `Bearer ${token}`;
                            return instance(originalConfig); // Retry request
                        })
                        .catch((err) => Promise.reject(err));
                }

                // Start the refresh process
                isRefreshing = true;

                try {
                    // No longer needed since we are checking token validity on each request and session timeout is handled globally app.js
                    // if(TokenService.getUserIdle() === true) {
                    //     showToastMessage('You have been idle for too long. Redirecting to login...', 'error');
                    //     setTimeout(() => {
                    //         processQueue(err, null);
                    //         TokenService.removeUser();
                    //         window.location.href = `${dirPath}login`;
                    //     }, 3000);
                    // }

                    const response = await instance.post("auth/refresh", {
                        token: TokenService.getAccessToken(),
                        user_id: TokenService.getUserId()
                    });

                    // Check if the response contains a valid token
                    if (response.data.status && response.data.token) {
                        const newToken = response.data.token;
                        TokenService.updateAccessToken(newToken);

                        // Resolve the queued requests with the new token
                        processQueue(null, newToken);

                        // Retry the original request with the new token
                        originalConfig.headers["Authorization"] = `Bearer ${newToken}`;
                        return instance(originalConfig);

                    } else {

                        // If refresh response indicates failure, l
                        processQueue(err, null);
                        TokenService.removeUser();
                        window.location.href = `${dirPath}login`;
                        return Promise.reject(new Error("Failed to refresh token"));
                    }

                } catch (refreshError) {
                    processQueue(refreshError, null);
                    TokenService.removeUser();
                    window.location.href = `${dirPath}login`;
                    return Promise.reject(refreshError);
                } finally {
                    isRefreshing = false; // Reset the refresh state
                }
            }

            // Handle 500 Internal Server Error
            if (err.response.status === 500 && !originalConfig._retry) {
                originalConfig._retry = true;

                return retryFailedRequest(originalConfig).catch((retryError) => {
                    showToastMessage("Request failed after retry. Please reload page again.", "error");
                    return Promise.reject(retryError);
                });
            }

        }        

        return Promise.reject(err);
    }
);
export default instance;